<template>
	<section v-if="visitedHypermarketInstance" class="container">
		<div class="flex flex-col gap-y-6 mb-6 md:mb-8">
			<h2 v-if="blok.title" class="typo-h1 mb-0" v-text="blok.title" />
			<RichText
				v-if="blok.text"
				:data="blok.text"
				class="rem:max-w-[820px] hidden sm:block typo-body-l"
			/>
		</div>
		<div class="overflow-x-hidden">
			<CarouselSkeleton
				:items="gastroProducts?.result ?? []"
				class="mb-6 md:mb-12"
				list-class="inline-flex w-full min-w-max gap-6 xl:min-w-full xl:w-fit xl:grid xl:grid-cols-5"
				page-per-item
				snap-items
				center-item-snap
			>
				<template #item="{item: product}">
					<li :key="product.offerId" class="rem:w-[230px] xl:w-full">
						<AbsoluteInternalLink :to="branchSpecificPath({name: 'online-objednavka-slug', params: {slug: 'reznictvi'}})">
							<GOOSProductTile :product="product" is-static class="h-full" />
						</AbsoluteInternalLink>
					</li>
				</template>
			</CarouselSkeleton>
		</div>
		<div class="w-full flex justify-center">
			<AbsoluteInternalLink class="btn btn-primary btn-lg max-sm:w-full max-sm:justify-center mx-auto md:mt-12" :to="branchSpecificPath({name: 'online-objednavka-slug', params: {slug: 'reznictvi'}})">
				Objednat online
				<NuxtIcon
					name="arrow-right-circle"
					class="text-2xl"
					filled
				/>
			</AbsoluteInternalLink>
		</div>
	</section>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';
	import {ProductionTypeIdEnum} from '~/stores/shoppingCart';
	import {useGoosGastroStore} from '~/stores/goos/gastro';
	import type {ButcheryProductPresentationStoryblok} from '~/storyblok/types';

	interface Props {
		blok: ButcheryProductPresentationStoryblok;
	}

	defineProps<Props>();

	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarket} = storeToRefs(hypermarketsStore);
	const {visitedHypermarketInstance} = useVisitedHypermarket();
	const branchSpecificPath = useBranchSpecificPath();

	const goosGastroStore = useGoosGastroStore();

	const {data: gastroProducts} = await useAsyncData('ButcheryProductPresentation',
		async () => {
			if (!visitedHypermarketInstance.value) {
				return null;
			}

			return await goosGastroStore.fetchOffers({
				localityId: parseInt(visitedHypermarketInstance.value.content.gsoaId),
				productTypeId: ProductionTypeIdEnum.BUTCHERY,
				offset: 0,
				limit: 5,
			});
		},
		{watch: [selectedHypermarket]},
	);
</script>
